import type { CSSProperties } from 'react';

interface SkeletonProps {
  height?: number | string;
  width?: number | string;
  style?: CSSProperties;
}

/**
 * Loading placeholder shimmer. Respects current theme variables (no hardcoded colors
 * beyond the legacy rgba values used in index.html:1930).
 */
export function Skeleton({ height = 16, width = '100%', style }: SkeletonProps) {
  return (
    <div
      aria-busy="true"
      style={{
        display: 'inline-block',
        height,
        width,
        background:
          'linear-gradient(90deg, rgba(15,45,100,0.15) 0%, rgba(15,45,100,0.35) 50%, rgba(15,45,100,0.15) 100%)',
        backgroundSize: '200% 100%',
        animation: 'tier1Shimmer 1.4s infinite linear',
        borderRadius: 6,
        ...style,
      }}
    />
  );
}
